import { format } from "date-fns"
import type { DateArg } from "date-fns"
import { ISO_DATE_TIME_FORMAT } from "@/modules/calendar/constants/iso-formats"

export default function formatToISODateTime(date: DateArg<Date> & {}): string {
  return format(new Date(date), ISO_DATE_TIME_FORMAT)
}
